import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-postcodeusers-main",
    templateUrl: "./postcodeusers.main.component.html",
    standalone: false
})
export class PostcodeUsersMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
